<ng-container *ngIf="ios && android">
    <div class="title">
        <h1>
            <strong>Commandez sur votre mobile</strong>
        </h1>
    </div>
    <div class="d-flex align-items-center">
        <div class="text-center">
            <h1>
                Avec notre application mobile vous pouvez passer des commandes facilement et rapidement depuis votre
                smartphone
            </h1>
            <a href="https://play.google.com/store/apps/details?id={{android}}" target="_blank">
                <img src="assets/images/android.png" alt="application android" width="300px">
            </a>
            <a href="https://apps.apple.com/fr/app/{{ios}}" target="_blank">
                <img src="assets/images/ios.png" alt="application ios" width="300px">
            </a>
        </div>
        <div>
            <img class="pull-right" src="assets/images/mobile.png" alt="application mobile">
        </div>
    </div>
</ng-container>